import { render, staticRenderFns } from "./disease_science.vue?vue&type=template&id=6bafeed1&scoped=true&"
import script from "./disease_science.vue?vue&type=script&lang=js&"
export * from "./disease_science.vue?vue&type=script&lang=js&"
import style0 from "./disease_science.vue?vue&type=style&index=0&id=6bafeed1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bafeed1",
  null
  
)

export default component.exports